import { render } from "./NewExport.vue?vue&type=template&id=448c63d7"
import script from "./NewExport.vue?vue&type=script&lang=js"
export * from "./NewExport.vue?vue&type=script&lang=js"

import "./NewExport.vue?vue&type=style&index=0&id=448c63d7&lang=css"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__